import { FC, ReactNode } from 'react'

import styled from 'styled-components'

import PlayIcon from 'src/Assets/Svg/play-2.svg?react'
import trackCoverDefault from 'src/Assets/Svg/common/track-cover.svg'
import { secondaryButtonStyles } from 'src/Components/Buttons/PrimaryButton'
import { SmartImage } from 'src/Components/SmartImage'
import { variables } from 'src/Styled/variables'

export interface PlaylistButtonProps {
  playlistName: string
  playlistUrl?: string
  playlistCoverUrl?: string
  children?: ReactNode
  showPlay?: boolean
  className?: string
}

const Cover = styled(SmartImage)`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
`

const Text = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  font-size: ${variables.fontSize12};
  font-weight: ${variables.fontWeight400};
`

const PlaylistName = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
`

const Play = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`

const Container = styled.a<{ $loading?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  padding: 8px 12px 8px 8px;
  border-radius: 16px;
  box-sizing: border-box;
  text-decoration: none;
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;

  ${secondaryButtonStyles}

  &:hover {
    color: ${({ theme }) => theme.color.darkGrey};
  }

  &:focus-visible ${Text} {
    color: ${({ theme }) => theme.color.darkGrey};
  }
`

export const PlaylistButton: FC<PlaylistButtonProps> = ({
  playlistName,
  playlistUrl,
  playlistCoverUrl,
  children,
  showPlay = true,
  className,
}) => (
  <Container
    href={playlistUrl}
    target='_blank'
    rel='noopener noreferrer'
    className={className}
  >
    <Cover
      width={32}
      height={32}
      fallbackSrc={trackCoverDefault}
      src={playlistCoverUrl}
    />
    <Text>
      <PlaylistName>{playlistName}</PlaylistName>
      {children}
    </Text>
    {showPlay && (
      <Play>
        <PlayIcon />
        <span>Play</span>
      </Play>
    )}
  </Container>
)
